import _ from "underscore";
import { View, CollectionView } from "backbone.marionette";
import t from "../react/helpers/t";
import { moment, Backbone } from "../../vendor";

/**
 * @class InboomaSelectBox
 * @author Felix Albroscheit
 *
 * Standalone plugin to render a reactive and searchable
 * (dropdown) select-box. Free of jQuery!
 */

const InboomaSelectBoxField: any = View.extend({
  className: "inbooma-select-box-results__field",
  tagName: "li",

  template: _.template(`
        <% if ( advancedUserList ) { %>
            <span class="inb-select-width-1"><%- last_name %></span>
            <span class="inb-select-width-1"><%- first_name %></span>
            <span class="inb-select-width-2"><%- customer_nbr %></span>
            <span class="inb-select-width-3"><%- shorten(email,30) %></span>
            <span class="inb-select-width-4"><%- moment(created).format('DD.MM.YYYY, HH:mm') %></span>
            <div id="tt_<%- id %>" class="tooltip <% if (advancedUserList && !quickOrder) print('advanced'); %>" style="top:<%- tooltipPosition() %>">
                <label><%- _listItemContent %></label>
                <label><i class="fi fi-torso"></i><%- customer_nbr %></label>
                <label><i class="fi fi-mail"></i> <%- email %></label>
                <!--label><i class="fi fi-telephone"></i> <% typeof phone_number === 'undefined' ? print('-') : phone_number %></label-->
                <label><div class="inb-fi-card"></div> <% id_card_nbr == null ? print('-') : id_card_nbr %></label>
                <label><div class="inb-fi-created-at"></div> <%- moment(created).format('DD.MM.YYYY, HH:mm') %></label>
            </div>
        <% } else if ( _listItemContent !== '') { %>
            <%- _listItemContent %>
        <% } %>
    `),

  templateContext(): any {
    return {
      advancedUserList: this.getOption("advancedUserList"),
      quickOrder: this.getOption("quickOrder"),
      moment,
      shorten: (value: any, maxLength: number): any => {
        let maxWidth: number =
          window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; // does only work for initial value and not for resize
        console.log("max width: ", maxWidth);
        if (maxWidth < 500) {
          maxLength = 16; // set fixed limit for small screens
        }
        if (value === undefined || value == null) return "";
        if (value.length > maxLength && maxLength > 3) {
          return value.substring(0, maxLength - 3) + "...";
        } else {
          return value;
        }
      },
      tooltipPosition: () => {
        /*let offset = 60;
                let lineHeight = 30;
                console.log("MODEL: ",this.model);
                for (var i=0;i<this.model.collection.models.length;i++) {
                    if (this.model.get('id') == this.model.collection.models[i].get('id')) {
                        return offset + i * lineHeight + 'px;';
                    }
                }
                return offset + 'px;';*/
        return "60px";
      },
    };
  },

  events: {
    mousedown: "_onClick", // Better than click event
  },

  _onClick(): void {
    this.getOption("onSelectItem")(this.model);
  },

  onRender(): void {
    if (!this.getOption("advancedUserList"))
      this.$el[0].setAttribute("title", this.model.get("_listItemContent"));
    if (this.model.get("_listItemContent") === "") {
      this.$el[0].classList.add("hide");
    }
  },
});

export default CollectionView.extend({
  _query: "",
  _queryMemory: {},
  _hasActiveSelection: false,

  options: {
    // default values
    placeholder: "Search",
    onSearch: _.noop,
    onSelectItem: _.noop,
    onReset: _.noop,
    listItemContent: _.noop,
    selectedItem: null,
    sortBy: "id",
    sortDirection: "asc",
    advancedUserList: false,
    quickOrder: false,
    inputStyle: "",
    openListOnClose: true,
    useQueryMemory: true,
  },

  template: _.template(`
        <div class="inbooma-select-box <% if (advancedUserList && !quickOrder) print('advanced'); else if (quickOrder) print('quick-order');%>">
            <input 
             class="inbooma-select-box__input" <% if (inputStyle) print('style='+inputStyle);%>
             placeholder="<%- placeholder %>" 
            />
            <a
             href="#"
             class="inbooma-select-box__reset hide" <% if (advancedUserList) print('style="float:unset;"');%> >
             x
            </a>
            
            <ul class="inbooma-select-box-results hide <% if (quickOrder) print('quick-order-offset');%>">
            <% if (advancedUserList) { %>
            <div class="inb-select-results-head hide">
                <span id="select_sort_2" class="inb-select-sort-menu inb-select-width-1 <%= isActiveSort('last_name') ? ' active' : '' %>" 
                      title="<%= title_2 %>"><a href="#" class="inb-select-box-sort"> <%= t('last_name',null,'capital') %>
                      <i id="sort_arrow_2" class="fi-play <%= getDirection('last_name') %>"></i> </a> </span>
                <span id="select_sort_1" class="inb-select-sort-menu inb-select-width-1 <%= isActiveSort('first_name') ? ' active' : '' %>"
                      title="<%= title_1 %>"><a href="#" class="inb-select-box-sort"> <%= t('first_name',null,'capital') %>
                      <i id="sort_arrow_1" class="fi-play <%= getDirection('first_name') %>"></i> </a> </span>
                <span id="select_sort_3" class="inb-select-sort-menu inb-select-width-2 <%= isActiveSort('user_customer_nbr') ? ' active' : '' %>"
                      title="<%= title_3 %>"><a href="#" class="inb-select-box-sort"> <%= t('user_nbr',null,'capital') %>
                      <i id="sort_arrow_3" class="fi-play <%= getDirection('user_customer_nbr') %>"></i> </a> </span>
                <span id="select_sort_4" class="inb-select-sort-menu inb-select-width-3 <%= isActiveSort('email') ? ' active' : '' %>"
                      title="<%= title_4 %>"><a href="#" class="inb-select-box-sort"> <%= t('e-mail',null,'capital') %>
                      <i id="sort_arrow_4" class="fi-play <%= getDirection('email') %>"></i> </a> </span>
                <span id="select_sort_5" class="inb-select-sort-menu inb-select-width-4 <%= isActiveSort('created') ? ' active' : '' %>"
                      title="<%= title_5 %>"><a href="#" class="inb-select-box-sort"> <%= t('created_at',null,'capital') %>
                      <i id="sort_arrow_5" class="fi-play <%= getDirection('created') %>"></i> </a> </span>
            </div>
            <% } %>
            </ul>
            <a id="inbooma-select-box-warning" class="fi fi-alert hide" title="<%= t('user_duplicate_info',null,'capital') %>"><%= t('user_duplicate_warning',null,'capital') %></a>
        </div>
    `),

  templateContext() {
    return {
      t, // using react helper to make t somehow available here
      title_1: t("sort_by_${a}", { a: t("first_name") }), // using variables inside template does not work with react helper
      title_2: t("sort_by_${a}", { a: t("last_name") }), // -> defining them here solved the problem
      title_3: t("sort_by_${a}", { a: t("user_customer_nbr") }),
      title_4: t("sort_by_${a}", { a: t("e-mail") }),
      title_5: t("sort_by_${a}", { a: t("created") }),
      placeholder: this.getOption("placeholder"),
      advancedUserList: this.getOption("advancedUserList"),
      inputStyle: this.getOption("inputStyle"),
      quickOrder: this.getOption("quickOrder"),
      isActiveSort: (sort: any): boolean => {
        if (sort == this.getOption("sortBy")) return true;
        return false;
      },
      getDirection: (sort: any): string => {
        if (sort == this.getOption("sortBy")) {
          return this.getOption("sortDirection");
        } else {
          return "asc";
        }
      },
    };
  },

  childView: InboomaSelectBoxField,
  childViewContainer: ".inbooma-select-box-results",

  childViewOptions() {
    return {
      onSelectItem: this._onSelectItem.bind(this),
      advancedUserList: this.getOption("advancedUserList"),
      quickOrder: this.getOption("quickOrder"),
      query: this._query, // @todo Highlight filtered result
    };
  },

  _activeScrollEvent: false,

  ui: {
    resultsList: ".inbooma-select-box-results",
    resultsListHeader: ".inb-select-results-head",
    sortMenu: ".inb-select-sort-menu",
    searchInput: ".inbooma-select-box__input",
    reset: ".inbooma-select-box__reset",
    duplicateWarning: "#inbooma-select-box-warning",
  },

  events: {
    "keyup @ui.searchInput": "_search",
    "focusin @ui.searchInput": "open",
    "focusout @ui.searchInput": "close",
    "click @ui.reset": "_reset",
    "mousedown @ui.resultsList"(): void {
      // @ts-ignore
      this._activeScrollEvent = true;
    },
    "mouseup @ui.resultsList"(): void {
      // @ts-ignore
      this._activeScrollEvent = false;
    },
    //'click @ui.resultsListHeader' : '_sort',
    "click @ui.sortMenu": "_sort",
  },

  _sort(ev: any): void {
    let el: any = ev.target.parentNode;
    let sort_dir: any = null;

    if (ev.target.tagName == "I") el = ev.target.parentNode.parentNode;

    this._setActiveSort(el);

    switch (el.id) {
      case "select_sort_1":
        // sort by first name
        sort_dir = this._toggleSortDirection("sort_arrow_1");
        if (sort_dir != null) {
          console.log("new sort direction: ", sort_dir);
          /*
                    this.collection._pagination['sort'] = 'first_name';
                    this.collection._pagination['direction'] = sort_dir;
                    this.collection._filterParams['direction'] = sort_dir;              // set params explicitly
                    this.collection.addFilter('direction',sort_dir);                     // add doubled filter param to really trigger refetch
                    */
          this.collection.setSort("first_name", sort_dir, true);
        }
        break;
      case "select_sort_2":
        // sort by last name
        sort_dir = this._toggleSortDirection("sort_arrow_2");
        if (sort_dir != null) {
          /*
                    this.collection._pagination['sort'] = 'last_name';
                    this.collection._pagination['direction'] = sort_dir;
                    //this.collection._pagination['current_page'] = 0;
                    //this.collection._refetchCollection(false,null);
                    //this.collection._filterParams['sort'] = 'last_name';               // set params explicitly
                    this.collection.addFilter('direction',sort_dir);                     // add doubled filter param to really trigger refetch
                    */
          this.collection.setSort("last_name", sort_dir, true);
        }
        break;
      case "select_sort_3":
        // sort by customer number
        sort_dir = this._toggleSortDirection("sort_arrow_3");
        if (sort_dir != null) {
          /*
                    this.collection._pagination['sort'] = 'created';
                    this.collection._pagination['direction'] = sort_dir;                 // set params explicitly
                    this.collection.addFilter('direction',sort_dir);                     // add doubled filter param to really trigger refetch
                    */
          this.collection.setSort("customer_nbr", sort_dir, true);
        }
        break;
      case "select_sort_4":
        // sort by email
        sort_dir = this._toggleSortDirection("sort_arrow_4");
        if (sort_dir != null) {
          /*
                    this.collection._pagination['sort'] = 'email';
                    this.collection._pagination['direction'] = sort_dir;
                    //this.collection._filterParams['sort'] = 'email';                   // set params explicitly
                    this.collection.addFilter('direction',sort_dir);                     // add doubled filter param to really trigger refetch
                    */
          this.collection.setSort("email", sort_dir, true);
        }
        break;
      case "select_sort_5":
        // sort by created at
        sort_dir = this._toggleSortDirection("sort_arrow_5");
        if (sort_dir != null) {
          /*
                    this.collection._pagination['sort'] = 'created';
                    this.collection._pagination['direction'] = sort_dir;
                    //this.collection._filterParams['sort'] = 'created';                 // set params explicitly
                    this.collection.addFilter('direction',sort_dir);                     // add last filter param and trigger refetch
                    */
          this.collection.setSort("created", sort_dir, true);
        }
        break;
    }
  },

  _toggleSortDirection(id: any): any {
    const el: any = document.getElementById(id);

    if (el.className.indexOf("asc") < 0 && el.className.indexOf("desc") >= 0) {
      // current direction is 'desc'
      el.className = el.className.replace("desc", "asc");
      return "asc";
    } else if (el.className.indexOf("asc") >= 0 && el.className.indexOf("desc") < 0) {
      // current direction is 'asc'
      el.className = el.className.replace("asc", "desc");
      return "desc";
    } else {
      // direction inconsistent
      return null;
    }
  },

  _setActiveSort(el: any): void {
    if (el.className.indexOf("inb-select-sort-menu") < 0) return;

    if (el.className.indexOf("active") >= 0) return; // only direction has been changed -> do nothing

    // find active element
    let elems: any = document.getElementsByClassName("active");
    for (let i: number = 0; i < elems.length; i++) {
      if (elems[i].parentNode.className.indexOf("inb-select-results-head") >= 0) {
        // found active sort element
        elems[i].classList.remove("active");
        el.classList.add("active");
        return;
      }
    }
  },

  _onSelectItem(model: any): void {
    this._hasActiveSelection = true;
    this.getUI("searchInput")[0].value = model.get("_listItemContent");
    this.close();
    this.getUI("reset")[0].classList.remove("hide");
    this.getOption("onSelectItem")(model);
  },

  /**
   * Open resultlist
   * @return {instance}
   */
  open(): any {
    const vcard: HTMLElement | null = document.getElementById("order-vcard");
    if (vcard !== undefined && vcard != null) vcard.classList.add("hide");
    this.getUI("resultsList")[0].classList.remove("hide");
    if (this.getOption("advancedUserList"))
      this.getUI("resultsListHeader")[0].classList.remove("hide");
    this.getUI("duplicateWarning")[0].classList.add("hide");

    return this;
  },

  /**
   * return open status
   * @return {boolean}
   */
  isOpen(): boolean {
    return !(this.getUI("resultsList")[0].className.indexOf("hide") >= 0);
  },

  /**
   * Close resultslist
   * @return {instance}
   */
  close(ev: any): any {
    const vcard: HTMLElement | null = document.getElementById("order-vcard");
    if (vcard !== undefined && vcard != null) vcard.classList.remove("hide");

    if (this._activeScrollEvent && this.getOption("openListOnClose")) {
      return;
    }

    this.getUI("resultsList")[0].classList.add("hide");
    if (this.getOption("advancedUserList"))
      this.getUI("resultsListHeader")[0].classList.add("hide");
    if (this._userDuplicates !== undefined && this._userDuplicates === true)
      this.getUI("duplicateWarning")[0].classList.remove("hide");

    return this;
  },

  /**
   * proof if there are any duobled entities for selected user
   */
  checkForDuplicates(): void {
    const that: any = this;
    const item: any = this.getOption("selectedItem");

    if (item) {
      let model: any = null;

      if (typeof item === "string" || typeof item === "number") {
        model = this.collection.get(item.toString());
      } else if (typeof item.get("_listItemContent") !== "undefined") {
        model = item;
      }

      if (model) {
        let isUser = model.attributes.first_name !== undefined;
        if (isUser) {
          // fetch user by email
          const RequestHelper: any = Backbone.Model.extend({
            urlRoot: "/users?email=" + model.attributes.email,
          });

          new RequestHelper(null).fetch({
            success(model: any, response: any): void {
              if (response.success && response.data.length > 0) {
                // should found at least one user with that email
                if (response.data.length > 1) {
                  that.getUI("duplicateWarning")[0].classList.remove("hide");
                  that._userDuplicates = true;
                } else {
                  that.getUI("duplicateWarning")[0].classList.add("hide");
                  that._userDuplicates = false;
                }
              } else {
                console.log("ERROR: failed to get tags response");
              }
            },
            error(model: any, response: any): void {
              console.log("Error, could not request tags.");
            },
          });
        }
      }
    }
  },

  reset(): any {
    this._reset();
    return this;
  },

  /**
   * onClickResetBtn
   * Clears selection and opens resultslist
   */
  _reset(): boolean {
    this.setValue("");
    this.getOption("onReset")();

    if (this.getOption("openListOnClose")) {
      this.open();
    }

    return false;
  },

  /**
   * Manually trigger set value event on input field
   * @param {String} query Value to be set
   * @return {instance}
   */
  setValue(query: any): any {
    this.getUI("searchInput")[0].value = query;

    if (this.getOption("advancedUserList")) {
      if (query.length == 0) this.getUI("reset")[0].classList.add("hide");
      else this.getUI("reset")[0].classList.remove("hide");
    } else {
      this._toggleResetBtn();
      this._search();
      // request user directly
    }

    return this;
  },

  _toggleResetBtn(): void {
    if (this._query === "") {
      this.getUI("reset")[0].classList.add("hide");
    } else {
      this.getUI("reset")[0].classList.remove("hide");
    }
  },

  _search(): void {
    if (this.getOption("advancedUserList")) {
      this._hasActiveSelection = false;
      this._toggleResetBtn();

      let n_query: string = this.getUI("searchInput")[0].value.toLowerCase();
      this.collection.addFilter("n", n_query); // add filter param to search in first_name and last_name starting with query, trigger refetch
    } else {
      this._hasActiveSelection = false;

      const that: any = this,
        query: string = this.getUI("searchInput")[0].value.toLowerCase();

      const queryFilter: (view: any, index: any, children: any) => boolean = (
        view: any,
        index: any,
        children: any,
      ): boolean => {
        if (typeof view.model.attributes._listItemContent === "undefined") {
          // Just to be sure :)
          that._makeModelListItemContent(view.model);
        }

        if (typeof view.model.get("active") !== "undefined") {
          if (!view.model.get("active")) {
            return false;
          }
        }

        return view.model.get("_listItemContent").toLowerCase().indexOf(query) >= 0;
      };

      this._query = query;
      this.setFilter(queryFilter);
      this._toggleResetBtn();

      if (
        this.getOption("useQueryMemory") &&
        query !== "" &&
        typeof this._queryMemory[query] === "undefined"
      ) {
        this._queryMemory[query] = true;
        this.getOption("onSearch")(query);
      }
    }
  },

  _makeModelListItemContent(model: any): void {
    model.set("_listItemContent", this.getOption("listItemContent")(model));
    if (model.get("first_name") !== undefined)
      model.set("_listItemFirstName", model.get("first_name"));
    if (model.get("last_name") !== undefined)
      model.set("_listItemLastName", model.get("last_name"));
    if (model.get("customer_nbr") !== undefined)
      model.set("_listItemCustomerNumber", model.get("customer_nbr"));
    if (model.get("email") !== undefined) model.set("_listItemEmail", model.get("email"));
    if (model.get("created") !== undefined) model.set("_listItemCreated", model.get("created"));
  },

  initialize(): void {
    const that: any = this;

    _.each(this.collection.models, function (model: any): void {
      that._makeModelListItemContent(model);
    });

    this.collection.on("add", function (model: any): void {
      that._makeModelListItemContent(model);
    });

    // Sort models: Sorting should be handled by the API to avoid the
    // implementation of multiple sort-logics. Pass sorting options to
    // your API call in the onSearch handler.
    // Nevertheless, if you rely on local sort, wrap and use the following two lines:
    //this.collection.comparator = this.getOption('sortBy');
    //this.collection.sort(); // re-sort according to comparator!
    if (this.getOption("advancedUserList"))
      this.collection.setSort(this.getOption("sortBy"), this.getOption("sortDirection"), true);

    this.render();
  },

  onRender(): void {
    const item: any = this.getOption("selectedItem");

    if (item) {
      let model = null;

      if (typeof item === "string" || typeof item === "number") {
        model = this.collection.get(item.toString());
      } else if (typeof item.get("_listItemContent") !== "undefined") {
        model = item;
      }

      if (model) {
        //this.setValue(model.get('_listItemContent'));
        let isUser = model.attributes.first_name !== undefined;
        if (isUser) {
          this.getUI("searchInput")[0].value = model.get("_listItemContent");
          this.getUI("reset")[0].classList.remove("hide");
        } else this.setValue(model.get("_listItemContent"));

        // check if user has already been fetched
        let _id = model.get("id");
        let alreadyFetched = false;
        if (isUser) {
          for (let i: number = 0; i < this.collection.models.length; i++) {
            if (this.collection.models[i].get("id") == _id) {
              if (this.collection.models[i].get("_complete") === true) alreadyFetched = true; // user has been marked as completely fetched
              break;
            }
          }
        }
        if (_id !== undefined && _id != null && isUser && !alreadyFetched) {
          // fetch selected user, get full data
          const RequestHelper: any = Backbone.Model.extend({
            urlRoot: "/users/" + model.get("id"),
          });

          const that: any = this;
          new RequestHelper(null).fetch({
            success(model: any, response: any): void {
              if (response.success && response.data.id !== undefined) {
                let matchedModel: any = null;

                for (let i: number = 0; i < that.collection.models.length; i++) {
                  if (that.collection.models[i].get("id") == response.data.id) {
                    response.data._complete = true; // mark user as completely fetched
                    Object.assign(that.collection.models[i].attributes, response.data); // update collection item
                    that.collection.models[i].trigger("changed");
                    matchedModel = that.collection.models[i];
                    break;
                  }
                }
                if (matchedModel !== null) that.getOption("onSelectItem")(matchedModel); // call handler again after fetching user
              }
            },
            error(model: any, response: any): void {
              console.log("Error, could not request user.");
            },
          });
        }
      }
    }
  },
});
